import React from 'react';
import PropTypes from 'prop-types';

import { Tag } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const MissingPodCell = ({ missingPod, intl }) => {
  const t = intl.messages.modules.journey.card;
  return (
    missingPod && (
      <Tag skin="modernRed" weight="bold" textTransform="uppercase">
        {t.missing}
      </Tag>
    )
  );
};

MissingPodCell.propTypes = {
  missingPod: PropTypes.bool.isRequired,
};

export default injectIntl(MissingPodCell);
